import { useEffect } from 'react'
import { ITestKey } from '../interfaces/connection.interfaces'

export type UseTestKeysProps = {
  testKeyValues?: ITestKey[]
  currentMode?: 'edit' | 'create'
  availableFields: any
  resetField: (string) => void
  setValue: (field: string, value: string | boolean | void) => void
  trigger: (string) => void
}

export const useTestKeysV2 = ({
  testKeyValues,
  item,
  country,
  setValue,
  resetField,
  connectionResponse,
  setToggleState,
  trigger,
  isAvailableTest,
  setIsAvailableTest,
  params,
  getModeStatus,
  getFieldState,
}) => {
  const isAvailableTestKey = () => {
    if (getModeStatus() === 'ON') {
      if (connectionResponse?.test_credentials) {
        setIsAvailableTest(true)
      }
    }
  }
  const handleTestKeyButton = () => {
    setValue('params_with_test_values', isAvailableTest)
    setToggleState(true)
    params?.map((param) => {
      setValue(`${param.param_id}`, 'input_test_value', {
        shouldDirty: true,
        shouldValidate: true,
      })
    })
  }

  const resetTestKeyProps = () => {
    setValue('params_with_test_values', false)
    setToggleState(false)
    params?.map((param) => {
      setValue(`${param.param_id}`, resetField(param.param_id))
    })
  }

  const handleSetAvailableTest = () => {
    setIsAvailableTest(true)
  }
  useEffect(() => {
    isAvailableTestKey()
  }, [item, testKeyValues])

  useEffect(() => {
    connectionResponse?.test_credentials && setToggleState(true)
  }, [])

  return {
    isAvailableTest,
    handleTestKeyButton,
    resetTestKeyProps,
    handleSetAvailableTest,
    setIsAvailableTest,
  }
}
